import signatureList from "./signature-list";

/**
 * 获取文件二进制数组
 * @param {*} file
 * @param {*} param1
 * @returns
 */

export const getArrayBuffer = (file, { start = 0, end = 32 }) => {
  //
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onload = () => {
      let buffers = new Uint8Array(reader.result);
      resolve(buffers);
    };
    reader.onerror = err => {
      reject(err);
    };
    reader.onabort = err => {
      reject(err);
    };
    reader.readAsArrayBuffer(file.slice(start, end));
  });
};

function check(buffers, { signature, offset = 0 }) {
  for (let i = 0, len = signature.length; i < len; i++) {
    if (buffers[i + offset] !== signature[i] && signature[i] !== undefined) {
      return false;
    }
  }
  return true;
}
/**
 * @description 获取文件的真实类型
 * @param {File} file 文件对象实例
 * @param {Object} options 配置项，指定读取的起止范围
 */
export const getFileType = (file, options = { start: 0, end: 32 }) =>
  getArrayBuffer(file, options)
    .then((buffers) => {
      // 找出签名列表中定义好的类型，并返回
      for (let i = 0, len = signatureList.length; i < len; i++) {
        if (check(buffers, signatureList[i])) {
          const { mime, ext } = signatureList[i];
          return { mime, ext };
        }
      }
      // 未找到则返回file对象中的信息
      return { mime: file.type, ext: "" };
    })
    .catch((err) => err);


// WEBPACK FOOTER //
// ./src/utils/file-type.js